import React from 'react';
import { useParams } from 'react-router-dom';
import { FormattedMessage } from '../../../util/reactIntl';
import EditListingPricingPagePackagesList from '../../../components/EditListingPricingPagePackagesList/EditListingPricingPagePackagesList';
import css from './EditListingPricingPageTwo.css';
import { Button, NamedLink, SecondaryButton } from '../../../components';
import {
    extraPackagesListingConfig,
    LISTING_PACKAGE_ANONYM_LISTING_ID,
    LISTING_PACKAGE_PRIVATE_LISTING_ID,
    LISTING_PACKAGE_SOCIAL_BOOST_ID,
} from '../../../marketplace-custom-config';
import { getSmallestPackagePrice } from '../../../util/extraPackages';
import { useInitialFormValueForAnonymIntention } from './useInitialFormValueForAnonymIntention';

export const BoostingSubmitButton = ({ values, currentUser, isNewListingFlow, initialValues }) => {
    const { userType } = currentUser?.attributes?.profile?.publicData || {};
    const { creditsAvailable = {} } = currentUser?.attributes?.profile?.privateData || {};

    const checkPackages = entry =>
        entry[LISTING_PACKAGE_SOCIAL_BOOST_ID] ||
        entry[LISTING_PACKAGE_ANONYM_LISTING_ID] ||
        entry[LISTING_PACKAGE_PRIVATE_LISTING_ID];

    const packagesList = [
        LISTING_PACKAGE_SOCIAL_BOOST_ID,
        LISTING_PACKAGE_ANONYM_LISTING_ID,
        LISTING_PACKAGE_PRIVATE_LISTING_ID,
    ];

    const untouched = packagesList.every(id => Boolean(values[id]) === Boolean(initialValues[id]));
    const anyOfPackageSelected = packagesList.some(id => Boolean(values[id]));

    const creditsAvailableByType = creditsAvailable[userType];
    const smallestPackagePrice = getSmallestPackagePrice(extraPackagesListingConfig);
    const lessThanSmallestPackagePrice =
        anyOfPackageSelected && creditsAvailableByType < smallestPackagePrice;

    const somePackagesInitiallySelected = checkPackages(initialValues);
    const somePackageSelected = checkPackages(values);
    const packagesSelectedOrDraft = (isNewListingFlow && somePackageSelected) || !isNewListingFlow;
    const noPackagesSelectedForNewListing = isNewListingFlow && !somePackageSelected;

    if (packagesSelectedOrDraft) {
        return (
            <Button
                type="submit"
                className={css.proceedWithPackageButton}
                disabled={lessThanSmallestPackagePrice || untouched}
            >
                {somePackagesInitiallySelected ? 'Änderungen speichern' : 'Aktivieren'}
            </Button>
        );
    }

    if (noPackagesSelectedForNewListing) {
        return (
            <SecondaryButton type="submit" className={css.proceedWithNoPackageButton}>
                Ohne Zusatzpaket veröffentlichen
            </SecondaryButton>
        );
    }

    return null;
};

export default ({ values, currentListing, currentUser, form }) => {
    const params = useParams();
    const { tab } = params;

    useInitialFormValueForAnonymIntention({ form, currentListing });

    return (
        <div className={css.pricingPageTwoWrapper}>
            <h3 className={css.secondPageTitle}>
                <FormattedMessage id={`EditListingPricingForm.extraPackageHeading-${tab}`} />
            </h3>
            <EditListingPricingPagePackagesList
                packagesType="listing"
                values={values}
                currentUser={currentUser}
                currentListing={currentListing}
                renderSubmitButton={() => (
                    <p className={css.pricingPageSideNote}>
                        Besuche die Seite{' '}
                        <NamedLink
                            openInNewTab
                            name="PricingPage"
                            to={{
                                hash: '#wie-viele-credits-brauche-ich',
                            }}
                        >
                            Preisgestaltung
                        </NamedLink>
                        , um mehr über Funktionen und Preise zu erfahren.
                    </p>
                )}
            />
        </div>
    );
};
